import { render, staticRenderFns } from "./InjuryFormDialog.vue?vue&type=template&id=5d4e1ee1"
import script from "./InjuryFormDialog.vue?vue&type=script&lang=js"
export * from "./InjuryFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports